import React, { Component, Fragment } from 'react';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Select, Button, Popup, Icon } from 'semantic-ui-react';

import {
  ColorTypeFilterOptions as ColorSetupTypeFilterOptions,
  ColorSetupTypeEnum,
  DefaultColors,
  DefaultCategoryColors,
} from '../helpers/constants';
import { Filter, Main } from 'Containers';
import {
  getColors,
  writeColors,
  resetSuccess,
} from '../state/colorsetup/actions';
import { errorToast, toastSuccess } from 'Common/ToastHelper';
import { DirtyWrapper } from 'Components';
import { resetDirty } from 'State/dirtyTracking/actions';
import { ColorSetupTableForm } from '../components/ColorSetupTableForm';
import { SERVED_ITEMS_COLOR_SETUP_FORM_NAME } from 'Common/FormEnum';

class ColorSetupContainer extends Component {
  state = {
    colorSetupType: ColorSetupTypeEnum.NutritionCode,
  };

  static path = '/serveditemsetup/color/setup';

  getRootUrl = () => {
    return this.props.match.url.replace(
      /\/serveditemsetup\/.*/gi,
      '/serveditemsetup/'
    );
  };

  componentDidMount() {
    const { colorSetupType } = this.state;
    this.props.getColors(colorSetupType);
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');
    if (this.props.success === 1) {
      toastSuccess('Colors have been saved');
      this.props.resetSuccess();
      this.props.resetDirty();
    }
  }

  handleSubmit = values => {
    this.props.writeColors(this.state.colorSetupType, values);
  };

  confirmChange = () => {
    const { colorSetupType } = this.state;
    this.props.getColors(colorSetupType);
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        shown: true,
        formName: SERVED_ITEMS_COLOR_SETUP_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: this.props.loading,
          disabled: this.props.loading,
        },
      },
    };
  };

  resetColors = () => {
    const { itemColors, change } = this.props;

    itemColors.forEach((i, index) => {
      let defaultColor = DefaultColors[i.Code] || '';
      if (i.Code === null) {
        defaultColor = DefaultCategoryColors[i.Id] || '';
      }
      change(
        SERVED_ITEMS_COLOR_SETUP_FORM_NAME,
        `${index}.Color`,
        defaultColor
      );
    });
  };

  render() {
    const { itemColors, fetching } = this.props;
    const { colorSetupType } = this.state;

    return (
      <Fragment>
        <Filter
          title={
            <React.Fragment>
              Color Setup
              <Popup
                trigger={<Icon name="question circle outline" />}
                content={
                  <div>
                    <h4>Color priorities</h4>1. being the highest and 3. the
                    lowest. <br /> E.g. If an Items color wasn't chosen it will
                    use the color chosen for the items Nutriton Code.
                    <ol>
                      <li>Item</li>
                      <li>Nutrition Code</li>
                      <li>Item Category</li>
                    </ol>
                  </div>
                }
              />
            </React.Fragment>
          }
        />
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column>
                <label className="text-orange">Configure Colors for</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column>
                <DirtyWrapper closeModalYesCallback={this.confirmChange}>
                  {showDirtyConfirm => (
                    <Select
                      fluid
                      options={ColorSetupTypeFilterOptions}
                      onChange={(e, data) => {
                        this.setState(
                          { colorSetupType: data.value },
                          showDirtyConfirm
                        );
                      }}
                      value={colorSetupType}
                      disabled={fetching}
                    />
                  )}
                </DirtyWrapper>
              </Grid.Column>
              <Grid.Column className="">
                <Button onClick={() => this.resetColors()}>
                  Reset To Default Colors
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <ColorSetupTableForm
            onSubmit={this.handleSubmit}
            initialValues={itemColors}
            data={itemColors}
            loading={fetching}
            colorSetupType={colorSetupType}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { ColorSetup } = state.ServedItemSetupState;
  return {
    fetching: ColorSetup.fetching,
    itemColors: ColorSetup.itemColors,
    fetchError: ColorSetup.fetchError,
    success: ColorSetup.success,
  };
};

export const ColorSetup = withRouter(
  connect(
    mapStateToProps,
    {
      getColors,
      writeColors,
      resetDirty,
      resetSuccess,
      change,
    }
  )(ColorSetupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/subpages/ColorSetup.js